import { useEffect, useMemo } from "react"

import { useDateParam, useResortParam } from "@/hooks/useSkipassFlow"
import useResorts from "@/queries/hooks/useResorts"

import { useDataLayerStore } from "./dataLayerStore"
import { pushToDataLayer, getLanguageCode, createBaseEvent } from "./helpers"

const DataLayer = () => {
  // Global queue state
  const { pendingEvents, removeProcessedEvent } = useDataLayerStore()

  // Data dependencies
  const { startDate } = useDateParam()
  const { resortExternalId } = useResortParam()
  const language = useMemo(getLanguageCode, [])
  const { data: resorts, isLoading: resortsLoading } = useResorts()

  // Current resort lookup
  const currentResort = useMemo(() => {
    if (!resorts || !resortExternalId) return null
    return resorts.find((resort) => resort.externalId === resortExternalId)
  }, [resorts, resortExternalId])

  // Process queue when resort data is available
  useEffect(() => {
    const isReady = !resortsLoading && !!currentResort

    if (!isReady || pendingEvents.length === 0) return

    // Process all pending events
    pendingEvents.forEach((pendingEvent) => {
      const eventData = createBaseEvent(
        pendingEvent.event,
        language,
        currentResort.name,
        startDate,
        null,
        pendingEvent.details
      )

      pushToDataLayer(eventData)
      removeProcessedEvent(pendingEvent.id)
    })
  }, [
    pendingEvents,
    resortsLoading,
    currentResort,
    language,
    startDate,
    removeProcessedEvent,
  ])

  return null // This component doesn't render anything
}

export default DataLayer
